import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconWarning: React.FC<Props> = ({
  width = 20,
  height = 20,
  color = "#D9A407",
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.99999 18.9582C5.05999 18.9582 1.04166 14.9398 1.04166 9.99984C1.04166 5.05984 5.05999 1.0415 9.99999 1.0415C14.94 1.0415 18.9583 5.05984 18.9583 9.99984C18.9583 14.9398 14.94 18.9582 9.99999 18.9582ZM9.99999 2.2915C5.74916 2.2915 2.29166 5.749 2.29166 9.99984C2.29166 14.2507 5.74916 17.7082 9.99999 17.7082C14.2508 17.7082 17.7083 14.2507 17.7083 9.99984C17.7083 5.749 14.2508 2.2915 9.99999 2.2915ZM10.625 13.7498V9.94063C10.625 9.59563 10.345 9.31563 9.99999 9.31563C9.65499 9.31563 9.37499 9.59563 9.37499 9.94063V13.7498C9.37499 14.0948 9.65499 14.3748 9.99999 14.3748C10.345 14.3748 10.625 14.0948 10.625 13.7498ZM10.85 7.08317C10.85 6.62317 10.4775 6.24984 10.0167 6.24984H10.0083C9.54833 6.24984 9.17907 6.62317 9.17907 7.08317C9.17907 7.54317 9.55667 7.9165 10.0167 7.9165C10.4767 7.9165 10.85 7.54317 10.85 7.08317Z"
      fill={color}
    />
  </svg>
);

export default IconWarning;
